import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import classNames from 'classnames';

import Button from '../../../Button';

import styles from './HomecardContent.module.scss';

const HomecardContentDescription = ({
  position = 'default',
  onMoreInfoClick
}) => {
  const isSimplifyHomecardsDesign =
    useSoyuzExperiment('SimplifyHomecardsDesignV2').get('behaviour') ===
    'variant';

  const descriptionClasses = classNames(
    styles[`homecard-content__info--${position}`],
    styles['homecard-content__info--animated']
  );

  return (
    <div className={descriptionClasses}>
      <Button color="link" onClick={onMoreInfoClick}>
        {isSimplifyHomecardsDesign
          ? trans('homecard.more.info.full')
          : trans('homecard.more.info')}
      </Button>
    </div>
  );
};

export default HomecardContentDescription;
